/**====================================================================
 * car img
 *====================================================================*/
import IS from '../images/lexus-main@2x1.png';
import ES from '../images/lexus-main@2x2.png';
import UX from '../images/lexus-main@2x3.png';
import NX from '../images/lexus-main@2x4.png';
import RX from '../images/lexus-main@2x5.png';
import LM from '../images/lexus-main@2x6.png';
import LS from '../images/lexus-main@2x7.png';
import LC from '../images/lexus-main@2x8.png';
import RCF from '../images/lexus-main@2x9.png';

export const CarSpec = [
  // IS
  {
    seriesName: 'IS',
    imgUrl: IS,
    categoryList: [
      {
        name: 'IS 300h 豪華版',
        price: '194萬',
        period_12: '57,500',
        period_24: '41,000',
        period_36: '35,300'
      },
      {
        name: 'IS 300h 頂級版',
        price: '204萬',
        period_12: '60,000',
        period_24: '42,700',
        period_36: '36,700'
      },
      {
        name: 'IS 300h F Sport版',
        price: '200萬',
        period_12: '59,000',
        period_24: '42,100',
        period_36: '36,200'
      },
      {
        name: 'IS 300h 頂級版 (天窗版)',
        price: '209萬',
        period_12: '61,200',
        period_24: '43,500',
        period_36: '37,300'
      }
    ]
  },
  // ES
  {
    seriesName: 'ES',
    imgUrl: ES,
    categoryList: [
      {
        name: 'ES 200 豪華版',
        price: '173萬',
        period_12: '38,200',
        period_24: '32,200',
        period_36: '30,400'
      },
      {
        name: 'ES 200 頂級版',
        price: '191萬',
        period_12: '40,900',
        period_24: '34,400',
        period_36: '32,500'
      },
      {
        name: 'ES 250 F Sport',
        price: '212萬',
        period_12: '44,100',
        period_24: '37,600',
        period_36: '35,700'
      },
      {
        name: 'ES 300h 豪華版',
        price: '197萬',
        period_12: '64,600',
        period_24: '44,600',
        period_36: '36,700'
      },
      {
        name: 'ES 300h 尊榮版',
        price: '221萬',
        period_12: '71,000',
        period_24: '48,800',
        period_36: '39,800'
      },
      {
        name: 'ES 300h 旗艦版',
        price: '243萬',
        period_12: '76,800',
        period_24: '52,500',
        period_36: '42,700'
      }
    ]
  },
  // UX
  {
    seriesName: 'UX',
    imgUrl: UX,
    categoryList: [
      {
        name: 'UX 200菁英版',
        price: '142.9萬',
        period_12: '33,800',
        period_24: '25,500',
        period_36: '25,200'
      },
      {
        name: 'UX 200菁英Plus版',
        price: '146.9萬',
        period_12: '34,700',
        period_24: '26,200',
        period_36: '26,000'
      },
      {
        name: 'UX 200 F Sport 勁化版',
        price: '168.9萬',
        period_12: '38,300',
        period_24: '28,900',
        period_36: '28,600'
      },
      {
        name: 'UX 250h豪華版',
        price: '149.9萬',
        period_12: '34,600',
        period_24: '26,200',
        period_36: '26,100'
      }
    ]
  },
  // RX
  {
    seriesName: 'RX',
    imgUrl: RX,
    categoryList: [
      {
        name: 'RX 450h頂級版',
        price: '314萬',
        period_12: '99,000',
        period_24: '69,500',
        period_36: '55,600'
      },
      {
        name: 'RX 450h F Sport版',
        price: '340萬',
        period_12: '106,000',
        period_24: '74,000',
        period_36: '59,000'
      },
      {
        name: 'RX 450h旗艦版',
        price: '344萬',
        period_12: '107,000',
        period_24: '74,700',
        period_36: '59,500'
      },
      {
        name: 'RX 450hL旗艦版 7人座',
        price: '353萬',
        period_12: '109,900',
        period_24: '76,600',
        period_36: '61,000'
      },
      {
        name: 'RX 450hL旗艦版 6人座',
        price: '353萬',
        period_12: '109,900',
        period_24: '76,600',
        period_36: '61,000'
      }
    ]
  },
  // LM
  {
    seriesName: 'LM',
    imgUrl: LM,
    categoryList: [
      {
        name: 'LM300h(7人座)',
        price: '372萬',
        period_12: '92,600',
        period_24: '64,000',
        period_36: '55,200'
      },
      {
        name: 'LM300h(4人座)',
        price: '520萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      }
    ]
  },
  // LS
  {
    seriesName: 'LS',
    imgUrl: LS,
    categoryList: [
      {
        name: 'LS 500h F Sport版',
        price: '475萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      },
      {
        name: 'LS 500h 頂級版',
        price: '475萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      },
      {
        name: 'LS 500h 旗艦版',
        price: '500萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      }
    ]
  },
  // LC
  {
    seriesName: 'LC',
    imgUrl: LC,
    categoryList: [
      {
        name: 'LC500',
        price: '580萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      },
      {
        name: 'LC500h',
        price: '610萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      },
      {
        name: 'LC500 Convertible',
        price: '608萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      }
    ]
  },
  // RCF
  {
    seriesName: 'RCF',
    imgUrl: RCF,
    categoryList: [
      {
        name: 'RC F',
        price: '373萬',
        period_12: '119,200',
        period_24: '87,500',
        period_36: '75,800'
      },
      {
        name: 'RC F Track Edition',
        price: '520萬',
        period_12: '客製報價',
        period_24: '客製報價',
        period_36: '客製報價'
      }
    ]
  }
];
